import { useEffect, useRef } from 'react';
import { useAppDispatch } from '@redux/store';

import { counterPartnerTaskTimer } from '@/redux/reducers/tasksReducer';

const useCountPartnerTaskDelay = (isTimersActive: boolean): void => {
  const timerId = useRef<NodeJS.Timeout | undefined>();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isTimersActive) {
      timerId.current = setInterval(() => {
        dispatch(counterPartnerTaskTimer());
      }, 1000);
    }

    if (!isTimersActive) {
      clearInterval(timerId.current);
    }

    return (): void => {
      clearInterval(timerId.current);
    };
  }, [isTimersActive]);
};

export { useCountPartnerTaskDelay };
